/**
 * Determines whether the user's device is a mobile device.
 * @returns {boolean} true if the user is on a mobile device, false otherwise
 * @category Utils
 */
export const isMobile = () => {
  const regex = /Mobile|Android|iPhone|iPad|Samsung/i
  return regex.test(navigator.userAgent) || (/Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
}
